/**
 * 해시 ID에 해당하는 요소로 스무스 스크롤
 * @param elementId - 스크롤할 요소의 ID (# 제외)
 * @param headerHeight - 헤더 높이 (오프셋)
 */
export const scrollToHash = (elementId: string, headerHeight: number) => {
  const element = document.getElementById(elementId);
  if (!element) return;

  const y =
    element.getBoundingClientRect().top + window.scrollY - headerHeight;
  window.scrollTo({ top: y, behavior: 'smooth' });
};

/**
 * 반응형 헤더 높이 반환
 * @param isXs - 모바일 여부 (breakpoints.down('sm'))
 */
export const getHeaderHeight = (isXs: boolean) => (isXs ? 64 : 92);
